import { useState } from "react";
import * as Bananas from "bananas-commerce-admin";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
import { Button, TableRow, Typography } from "@mui/material";

import { GiftStatusBadge } from "@/extensions/klarahill/components/GiftStatusBadge";
import { Case, Gift } from "@/extensions/klarahill/types";

import EditGiftDialog from "./EditGiftDialog";

import { Nullish } from "@/utils/types";

export interface GiftWithCertificateURL extends Gift {
  certificateUrl?: Nullish<URL>;
}

export interface GiftRowProps {
  case: Case;
  gift: GiftWithCertificateURL;
  onClick?: () => void;
  onMemoriamChange: (memoriam: string, memoriamFrom: string[]) => void;
}

export const GiftRow: React.FC<GiftRowProps> = ({
  case: { id: caseId },
  gift: {
    first_name,
    last_name,
    causes,
    certificateUrl,
    status,
    certificate_download_date,
    id,
    memoriam,
    memoriam_from,
  },
  onClick,
  onMemoriamChange,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const hasCauses = causes.length > 0;
  if (!hasCauses) console.error(`No causes for gift row: ${id}`);

  const isNew = certificate_download_date == null;

  return (
    <>
      <TableRow>
        <Bananas.TableCell>
          <GiftStatusBadge type={status} />
        </Bananas.TableCell>

        <Bananas.TableCell>
          {first_name} {last_name}
        </Bananas.TableCell>

        <Bananas.TableCell>
          {hasCauses ? causes[0]!.name : "Mottagare saknas"}
        </Bananas.TableCell>

        <Bananas.TableCell
          align="right"
          sx={{ pr: 3 }}
          typographyProps={{
            sx: { display: "flex", justifyContent: "flex-end", gap: 1 },
          }}
        >
          {certificateUrl != null ? (
            <Button
              color={isNew ? "primary" : "secondary"}
              href={String(certificateUrl)}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
                py: 0.25,
                px: 1,
                ml: "auto",
                minWidth: "unset",
                width: "fit-content",
                ...(isNew
                  ? {
                      bgcolor: "#003545",
                      color: "white",
                      ":hover": {
                        bgcolor: "#002834",
                        color: "white",
                      },
                    }
                  : {
                      bgcolor: "white",
                      borderColor: "#7F99A1",
                      color: "#003444",
                      ":hover": {
                        bgcolor: "background.paper",
                        borderColor: "background.paper",
                        color: "#525252",
                      },
                    }),
              }}
              target="_blank"
              variant={isNew ? "text" : "outlined"}
              onClick={onClick}
            >
              {isNew && (
                <Typography fontWeight={700} variant="button">
                  NY
                </Typography>
              )}

              <SaveAltOutlinedIcon sx={{ fontSize: "18px" }} />
            </Button>
          ) : null}
          <Button
            color="inherit"
            sx={{ minWidth: "unset", p: 0.5 }}
            variant="contained"
            onClick={() => setIsDialogOpen(true)}
          >
            <EditOutlinedIcon fontSize="small" />
          </Button>
        </Bananas.TableCell>
      </TableRow>
      <EditGiftDialog
        caseId={caseId}
        giftId={id}
        memoriam={memoriam}
        memoriamFrom={memoriam_from}
        open={isDialogOpen}
        setOpen={setIsDialogOpen}
        onChange={onMemoriamChange}
      />
    </>
  );
};

export default GiftRow;
